import { createContext, useContext } from 'react';
import type { CardDensity } from '@troia-v3/types';
import { DEFAULT_CARD_DENSITY, DENSITY_TOKENS, type DensityTokens } from './density';

const KanbanDensityContext = createContext<CardDensity>(DEFAULT_CARD_DENSITY);

/**
 * Provê a densidade escolhida para TODO o board (colunas + cards). Só o
 * `KanbanBoard` monta este provedor; ninguém mais precisa montar.
 */
export const KanbanDensityProvider: React.FC<{
  density: CardDensity;
  children: React.ReactNode;
}> = ({ density, children }) => (
  // O valor é uma string — não há objeto novo por render, então não há memo a fazer.
  <KanbanDensityContext.Provider value={density}>{children}</KanbanDensityContext.Provider>
);

/** Densidade corrente. Fora do provedor devolve 'normal'. */
export function useKanbanDensity(): CardDensity {
  return useContext(KanbanDensityContext);
}

/**
 * Tokens da densidade corrente. A referência é estável por densidade (constante
 * de módulo), então pode entrar direto em lista de dependências de efeito.
 */
export function useDensityTokens(): DensityTokens {
  return DENSITY_TOKENS[useKanbanDensity()];
}
